export default __webpack_public_path__ + "static/media/coi-story-logo.2516f262.svg";